import { useNavigate } from 'react-router-dom'
import { useGetTableValueQuery } from '../../../../../api/rtk/base/slices/tablesApiSlice'
import type { SpecialContributor } from '../types'

export const landLotsContributor: SpecialContributor = {
    id: 'landLots',
    useContribute: ({ objectTypeName, objectId }) => {
        const navigate = useNavigate()
        const enabled = objectTypeName === 'RoadLandLots' || objectTypeName === 'AdjacentLandLots'

        const { data: landSubLots, isFetching: isFetchingLandSubLots } = useGetTableValueQuery({
            tableValueUrl: 'objects/LandSubLots',
            filterStringArray: [`ParentLotId eq ${objectId}`],
            pages: true
        }, { skip: !enabled })
        const { data: landSubLotObjects, isFetching: isFetchingLandSubLotObjects } = useGetTableValueQuery({
            tableValueUrl: 'objects/LandSubLotObjects',
            filterStringArray: [`ParentLotId eq ${objectId}`],
            pages: true
        }, { skip: !enabled })
        const { data: encumbrances, isFetching: isFetchingEncumbrances } = useGetTableValueQuery({
            tableValueUrl: 'objects/Encumbrances',
            filterStringArray: [`LandLotId eq ${objectId}`],
            pages: true
        }, { skip: !enabled })
        const { data: landSingleOwners, isFetching: isFetchingLandSingleOwners } = useGetTableValueQuery({
            tableValueUrl: 'objects/LandSingleOwners',
            filterStringArray: [`LandLotId eq ${objectId}`],
            pages: true
        }, { skip: !enabled })
        const { data: landOwners, isFetching: isFetchingLandOwners } = useGetTableValueQuery({
            tableValueUrl: 'objects/LandOwners',
            filterStringArray: [`LandLotId eq ${objectId}`],
            pages: true
        }, { skip: !enabled })
        const { data: landOtherUsers, isFetching: isFetchingLandOtherUsers } = useGetTableValueQuery({
            tableValueUrl: 'objects/LandOtherUsers',
            filterStringArray: [`LandLotId eq ${objectId}`],
            pages: true
        }, { skip: !enabled })

        return {
            extraButtonsBySection: enabled ? {
                'Земельный участок': [
                    { format: 'button', type: 'action', actionKey: 'landLotComposition', caption: 'Состав ЗУ' },
                    { format: 'button', type: 'action', actionKey: 'landLotEncumbrances', caption: 'Ограничения (обременения)' },
                    { format: 'button', type: 'action', actionKey: 'landLotRights', caption: 'Права на ЗУ' },
                ]
            } : undefined,
            buttonsOptions: {
                customActions: {
                    landLotComposition: {
                        isLoading: isFetchingLandSubLots || isFetchingLandSubLotObjects,
                        disabled: !(landSubLots?.['@xdata.count'] || landSubLotObjects?.['@xdata.count']),
                        onClick: () => navigate('composition')
                    },
                    landLotEncumbrances: {
                        isLoading: isFetchingEncumbrances,
                        disabled: !encumbrances?.['@xdata.count'],
                        onClick: () => navigate('encumbrances')
                    },
                    landLotRights: {
                        isLoading: isFetchingLandSingleOwners || isFetchingLandOwners || isFetchingLandOtherUsers,
                        disabled: !(landSingleOwners?.['@xdata.count'] || landOwners?.['@xdata.count'] || landOtherUsers?.['@xdata.count']),
                        onClick: () => navigate('owners')
                    }
                }
            }
        }
    }
}


